import { createFileRoute, redirect } from "@tanstack/react-router";
import { salesDashboardRedirect } from "@/lib/staff-url-redirects";

export const Route = createFileRoute("/_protected/dashboard/sales")({
  beforeLoad: () => {
    throw redirect(salesDashboardRedirect());
  },
  component: () => null,
});
